import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
import type { Review } from '../data/reviews';
type ReviewCardProps = {
  review: Review;
  index: number;
  className?: string;
};
export function ReviewCard({
  review,
  index,
  className = ''
}: ReviewCardProps) {
  return <motion.figure initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.3,
    delay: index % 3 * 0.05,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative flex flex-col rounded-2xl border border-champagne bg-cream p-7 shadow-sm ${className}`} data-id="element-194" data-mp="3jhjl8hlk24xm">
      <QuoteIcon size={30} className="absolute right-6 top-6 text-raspberry/40" aria-hidden="true" data-id="element-195" data-mp="62di9j49loei" />
      <div className="flex gap-1 text-champagne-deep" aria-label="Five star review" data-id="element-196" data-mp="2cu5xsrz4qpou">
        {Array.from({
        length: 5
      }, (_, star) => <StarIcon key={star} size={15} fill="currentColor" data-id="element-197" data-mp="1sv05338ev8yi" />)}
      </div>
      <blockquote className="mt-5 text-[15px] leading-7 text-espresso" data-id="element-198" data-mp="1ww1vcukcoaoc">
        “{review.text}”
      </blockquote>
      <figcaption className="mt-auto border-t border-champagne pt-4 text-sm font-semibold text-raspberry" data-id="element-199" data-mp="21umvyv3ikwdb">
        <span className="mt-2 block" data-id="element-200" data-mp="26m4wxj5jewya">{review.role}</span>
      </figcaption>
    </motion.figure>;
}